import { __decorate, __metadata } from 'tslib';
import React from 'react';
import { Inject, Injectable, InjectorService } from '@tencent/ioc';
import { SurfaceService } from '../../services/surface/surface-service.js';
import { StateManager } from '../../services/store/state-manager.js';
import { TrackControllerService } from '../../services/controller/track-controller-service.js';
import { NetworkManagerWrapper } from '../../middlewares/network/netcheck-instance.js';

/**
 * 工作台上下文
 *
 * @public
 */
let WorkbenchContext = class WorkbenchContext {
    /**
     * 当前工作台打开的所有编辑器
     *
     * @readonly
     */
    get editors() {
        var _a;
        const surfaceService = InjectorService.get(SurfaceService);
        return ((_a = surfaceService === null || surfaceService === void 0 ? void 0 : surfaceService.editors) !== null && _a !== void 0 ? _a : []).map(info => info.editor);
    }
    /**
     * 当前工作台激活的编辑器
     *
     * @readonly
     */
    get editor() {
        const surfaceService = InjectorService.get(SurfaceService);
        if (surfaceService && this.editors.length > 0) {
            const surface = surfaceService.info.current;
            const surfaceId = surface === null || surface === void 0 ? void 0 : surface.id;
            return surfaceService.getEditor(surfaceId);
        }
        return null;
    }
    /**
     * 判断当前是否已连接互联网
     */
    isOnline() {
        return NetworkManagerWrapper.getInstance().isOnline;
    }
    /**
     * 获取状态库
     *
     * @readonly
     */
    get store() {
        return InjectorService.get(StateManager);
    }
    /**
     * 获取激活的 ActionPoint 信息
     */
    controllerInfo(point) {
        const key = point.from + point.name;
        return {
            configController: this.trackControllerService.getConfigController(key),
            callBackController: this.trackControllerService.getConfigController(key),
        };
    }
};
__decorate([
    Inject(),
    __metadata("design:type", TrackControllerService)
], WorkbenchContext.prototype, "trackControllerService", void 0);
WorkbenchContext = __decorate([
    Injectable()
], WorkbenchContext);
const defaultContext = new WorkbenchContext();
/**
 * React 组件 Context
 *
 * @public
 */
const EnvContext = React.createContext(defaultContext);

export { EnvContext, WorkbenchContext, defaultContext };
//# sourceMappingURL=context.js.map
